import React from 'react'

import GoogleAddressAutocomplete from './google_address_autocomplete'

const AddressAutocomplete = (props) => {
  return <GoogleAddressAutocomplete {...props} />
}

export default AddressAutocomplete
